import { ButtonLink } from '@components/atoms/ButtonLink';
import { Avatar } from '@components/atoms/Avatar';
import { Activity } from '@models/activity.model';
import { FC } from 'react';

interface ActivityHeaderProps {
  activity: Activity;
  rightLabel: React.ReactNode;
}

export const ActivityHeader: FC<ActivityHeaderProps> = ({
  activity,
  rightLabel,
}) => {
  return (
    <div className="flex justify-between">
      <div className="flex gap-2 items-center w-fit cursor-pointer">
        <Avatar
          src={activity.user?.avatar}
          alt={activity.user?.firstName}
          text={activity.user?.firstName}
        />
        {activity.user?.firstName && (
          <ButtonLink className="flex gap-2">
            <p className="text-sm font-medium">
              {activity.user?.firstName} {activity.user?.lastName}
            </p>
          </ButtonLink>
        )}
      </div>
      <div className="flex gap-2 text-sm items-center w-fit">{rightLabel}</div>
    </div>
  );
};
